import { parseResolveResponse } from "./parsers";

export const MSA_SERVER_URL =
  "https://msa-subscription.dep.grip.security/msa_subscription";

export interface ResolveResponse {
  id: string;
  name: string;
  status: string;
  plan: string;
  purchaserEmail: string;
  customerEmail: string;
  customerName: string;
  azureTenantId: string;
}

export async function resolvePurchaseToken(
  token: string,
  extraHeaders?: { "x-ms-requestid"?: string; "x-ms-correlationid"?: string }
): Promise<ResolveResponse> {
  const url = `${MSA_SERVER_URL}/resolve?token=${encodeURIComponent(token)}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      ...(extraHeaders || {}),
    },
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ message: resp.statusText }));
    throw new Error(`Resolve failed: ${JSON.stringify(err)}`);
  }
  return parseResolveResponse(await resp.json());
}

export async function activateSubscription(
  subscriptionId: string,
  extraHeaders?: { "x-ms-requestid"?: string; "x-ms-correlationid"?: string }
): Promise<{ status: string }> {
  const url = `${MSA_SERVER_URL}/subscriptions/${subscriptionId}/activate`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      ...(extraHeaders || {}),
    },
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ message: resp.statusText }));
    throw new Error(`Activate failed: ${JSON.stringify(err)}`);
  }
  return resp.json();
}
